// Presentation only. Server checkout and entitlement checks remain authoritative.
export function validMembershipPlans(rows = []) {
  return ['monthly', 'annual'].flatMap((id) => {
    const plan = rows.find((row) => String(row.id).toLowerCase() === id && row.is_active !== false && Number(row.price_usd ?? row.price) > 0 && row.paypal_plan_id);
    return plan ? [{ ...plan, id }] : [];
  });
}
export function membershipPath(id, signedIn) {
  const checkout = `/checkout/membership?plan=${id === 'annual' ? 'svod-annual' : 'svod-monthly'}`;
  return signedIn ? checkout : `/signup?return=${encodeURIComponent(checkout)}`;
}
export function formatPrice(amount, currency = 'USD') {
  try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', currencyDisplay: 'code' }).format(Number(amount)); }
  catch (_) { return `${Number(amount).toFixed(2)} ${currency}`; }
}
function positive(...values) { return values.map(Number).find((value) => Number.isFinite(value) && value > 0) ?? null; }
function tvod(raw) { return raw?.monetization?.tvod && typeof raw.monetization.tvod === 'object' ? raw.monetization.tvod : (raw?.tvod && typeof raw.tvod === 'object' ? raw.tvod : {}); }
export function publishedRental(item, parent = null) {
  const raw = item?.raw || item || {}, title = parent?.raw || parent || raw;
  const own = tvod(raw), base = tvod(title);
  const price = parent ? positive(own.rentalPrice, own.rental_price, own.price, own.amount, raw.rentalPrice, raw.rental_price, raw.tvodPrice, raw.tvod_price, raw.price, base.episodePrice, base.episode_price, base.perEpisodePrice, base.per_episode_price)
    : positive(base.rentalPrice, base.rental_price, base.price, base.amount, title.rentalPrice, title.rental_price, title.tvodPrice, title.tvod_price, title.rental?.price, title.pricing?.rental, title.pricing?.rentalPrice);
  const hours = positive(own.rentalWindowHours, own.rental_window_hours, base.rentalWindowHours, base.rental_window_hours, title.rentalWindowHours, title.rental_window_hours, 48);
  return { price, hours, currency: String(own.currency || base.currency || raw.currency || title.currency || 'USD').toUpperCase() };
}

export function safeReturnPath(value, fallback = '/profile') {
  const path = String(value || '');
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return fallback;
  try { const url = new URL(path, 'https://watchvim.com'); return url.origin === 'https://watchvim.com' ? url.pathname + url.search : fallback; } catch (_) { return fallback; }
}
